import React from 'react';

import styled from 'styled-components';

import { IInputProps } from '@rbi-ctg/frontend';

interface IBoxInputProps extends IInputProps {
  renderIcon?: () => React.ReactNode;
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  height: 46px;
  border: 1px solid #cac2c2;
  border-radius: 2px;
  margin: 10px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0.6rem;

  & svg {
    fill: ${Styles.color.secondary};
    opacity: 0.7;
  }
`;

const Input = styled.input`
  width: 100%;
  color: ${Styles.color.secondary};
  border: none;
  font-size: 0.95rem;
  opacity: 0.7;
  outline: none;
  padding-left: 0.65rem;

  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${Styles.color.secondary};
    opacity: 0.7;
  }
`;

const BoxInput: React.FC<IBoxInputProps> = ({ renderIcon, className, ...inputProps }) => (
  <Wrapper className={className}>
    {renderIcon && <IconContainer>{renderIcon()}</IconContainer>}
    <Input {...inputProps} />
  </Wrapper>
);

export default BoxInput;
